import MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry from "../../../sections/DirectiveEntry/entries/ExecutionEntry";

const ExecutionEntryOnGoingFinancialReview = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry
        showDiagnostic
      />
    </>
  );
}

export default ExecutionEntryOnGoingFinancialReview;
